import React from 'react';
import { Button } from './button';
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from './card';
import './FeatureHighlightModal.css';

/**
 * Modal component to display new feature highlights to admins
 * 
 * @param {Object} props
 * @param {Array} props.newFeatures - Array of {version, features: [{title, description, icon}]}
 * @param {Function} props.onDismiss - Called when user clicks "Got it" button
 * @param {boolean} props.isOpen - Whether the modal is visible
 */
const FeatureHighlightModal = ({ newFeatures, onDismiss, isOpen }) => {
  if (!isOpen || !newFeatures || newFeatures.length === 0) {
    return null;
  }

  // Flatten all features for display
  const totalFeatures = newFeatures.reduce((acc, v) => acc + v.features.length, 0);
  const latestVersion = newFeatures[0]?.version;

  return (
    <div className="feature-highlight-overlay" onClick={onDismiss}>
      <Card 
        className="feature-highlight-modal" 
        onClick={(e) => e.stopPropagation()}
      >
        <CardHeader className="feature-highlight-header">
          <div className="feature-highlight-badge">
            <span className="feature-highlight-badge-icon">🎉</span>
            <span>What's New</span>
          </div>
          <CardTitle className="feature-highlight-title">
            New in v{latestVersion}
          </CardTitle>
          <p className="feature-highlight-subtitle">
            {totalFeatures} new feature{totalFeatures !== 1 ? 's' : ''} to explore
          </p>
        </CardHeader>

        <CardContent className="feature-highlight-content">
          {newFeatures.map(({ version, features }) => (
            <div key={version} className="feature-highlight-version-group">
              {newFeatures.length > 1 && (
                <div className="feature-highlight-version-label">
                  Version {version}
                </div>
              )}
              <ul className="feature-highlight-list">
                {features.map((feature, index) => (
                  <li key={index} className="feature-highlight-item">
                    <span className="feature-highlight-item-icon">
                      {feature.icon}
                    </span>
                    <div className="feature-highlight-item-content">
                      <h4 className="feature-highlight-item-title">
                        {feature.title}
                      </h4>
                      <p className="feature-highlight-item-description">
                        {feature.description}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </CardContent>

        <CardFooter className="feature-highlight-footer">
          <Button 
            onClick={onDismiss}
            className="feature-highlight-dismiss-btn"
          >
            Got it, thanks!
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default FeatureHighlightModal;
